import { axiosMock } from '../client';
import { API_URL } from '../apiDictionary';
import {
  createPaginatedRandomSiteUsersList,
  createRandomSiteSubjectDetails,
} from '../../mocks/siteSubjects';

type PaginatedArgs = {
  page?: number;
  size?: number;
  sort?: string;
};

export const fetchSubjectListMock = async (
  id: string,
  args?: PaginatedArgs
) => {
  const data = createPaginatedRandomSiteUsersList(50, {
    page: args?.page ?? 1,
    size: args?.size ?? 10,
  });

  axiosMock.onGet(API_URL.subjectList).reply(200, data);
  axiosMock.onGet(API_URL.subjectList, {
    params: {
      page: args?.page ?? 0,
      size: args?.size ?? 10,
      sort: args?.sort,
      id,
    },
  });
};

export const fetchSubjectDetailsMock = async (id: string) => {
  const data = createRandomSiteSubjectDetails(10);

  axiosMock.onGet(API_URL.subjectDetail).reply(200, data);
  axiosMock.onGet(API_URL.subjectDetail, {
    params: {
      id,
    },
  });
};
